// import React, { useEffect } from 'react'
// import ReactDOM from 'react-dom'
// import { CSSTransition } from 'react-transition-group'
// import '../../styles/modal.scss'

// const Modal = (props) => {
//   const closeOnEscapeKeyDown = (e) => {
//     if ((e.charCode || e.keyCode) === 27) {
//       props.onClose()
//     }
//   }

//   useEffect(() => {
//     document.body.addEventListener('keydown', closeOnEscapeKeyDown)
//     return function cleanup() {
//       document.body.removeEventListener('keydown', closeOnEscapeKeyDown)
//     }
//   }, [])

//   return ReactDOM.createPortal(
//     <CSSTransition
//       in={props.show}
//       unmountOnExit
//       timeout={{ enter: 0, exit: 300 }}
//     >
//       <div className="modal" onClick={props.onClose}>
//         <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//           {/* <div className="modal-header">
//             <h4 className="modal-title">{props.title}</h4>
//           </div> */}
//           <div className="modal-body">{props.children}</div>
//           {/* <div className="modal-footer">
//             <button onClick={props.onClose} className="button">
//               Close
//             </button>
//           </div> */}
//         </div>
//       </div>
//     </CSSTransition>,
//     document.getElementById('root')
//   )
// }

// export default Modal

import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";

const VideoModal = (props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <img src={props.img} className="thumbnail" onClick={handleShow}/>

      <Modal show={show} onHide={handleClose} size="lg" >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <iframe
            width="100%"
            height="400rem"
            src={`https://www.youtube.com/embed/${props.videoId}`}
            title={props.name}
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default VideoModal;
